
    import '/opt/buildhome/repo/components/x-request/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["components-x-request-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/components/x-request/index.zh-CN.md?type=demo')
};